import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import CollapsibleContainer from '../../components/CollapsibleContainer';
import UpperContainer from '../../components/UpperContainer';
import { animateToScreen as animateToScreenAction } from '../../redux/ui/actions';
import TextColumnContent from '../../molecules/TextColumnContent';
import BackButtonContainer from '../../molecules/BackButtonContainer';
import Description from '../../components/Description';
import { H2, Text } from '../../components/Typography';

class AdditionalZonePassengersTexts extends PureComponent {
  render() {
    const { animateToScreen, t } = this.props;
    return (
      <>
        <BackButtonContainer
          home={t('Generic.breadcrumbHome')}
          homeLink={t('Generic.breadcrumbHomeLink')}
          secondaryHome={t('Generic.breadcrumbSecondaryHome')}
          secondaryHomeLink={t('Generic.breadcrumbSecondaryHomeLink')}
          textPrev={t('Flows.home')}
          text={t('Flows.additionalZone')}
          onClick={() => animateToScreen('Home')}
        />
        <TextColumnContent paddingTop={-100} hasBackButton>
          <H2>
            <Trans i18nKey="AdditionalZonePassengers.title" />
          </H2>
          <UpperContainer>
            <Description>
              <Text>
                <Trans i18nKey="AdditionalZonePassengers.description" />
              </Text>
            </Description>
          </UpperContainer>
          <CollapsibleContainer>
            <Collapsible
              trigger={t('Generic.additionalInfo')}
              transitionTime={300}
            >
              <Description>
                <Text>
                  <Trans i18nKey="AdditionalZonePassengers.description" />
                </Text>
              </Description>
            </Collapsible>
          </CollapsibleContainer>
        </TextColumnContent>
      </>
    );
  }
}

AdditionalZonePassengersTexts.propTypes = {
  animateToScreen: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  animateToScreen: (screenName) => dispatch(animateToScreenAction(screenName)),
});

// prettier-ignore
export default connect(null, mapDispatchToProps)(AdditionalZonePassengersTexts);
